module.exports = __webpack_public_path__ + "img/dk.63c806e6.svg";